// extracted by mini-css-extract-plugin
module.exports = {"link":"_105329b597--link--GGqRM","link--m":"_105329b597--link--m--l0k0I","link--xs":"_105329b597--link--xs--Xlt4E"};